import { render, staticRenderFns } from "./ProductRules.vue?vue&type=template&id=625640e8&scoped=true"
import script from "./ProductRules.vue?vue&type=script&lang=js"
export * from "./ProductRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625640e8",
  null
  
)

export default component.exports